module.exports = __webpack_public_path__ + "img/_PWK2704_-PSedit_.b404f8bd.jpeg";